var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-title"},[_c('div',{staticClass:"mr-auto"},[_vm._t("title-left")],2),_c('div',{staticClass:"ml-auto align-right"},[_vm._t("title-right")],2)]),_c('div',{staticClass:"card-body"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }